import { CatalogItem } from 'services/api-service'
import ContextEventBus, { EventBus } from 'util/event-bus'

export interface RegistrationInfo {
  registerFor: 'answer' | 'reply'
  stagedContentToken: string
}

export interface ConfirmedSubmitInfo {
  catItem: CatalogItem
  questionId?: number
  siteKey: string
  ugcType: 'answer' | 'reply'
}

export interface ISubmissionContext {
  answerText?: string
  confirmedSubmitComplete(info: ConfirmedSubmitInfo): void
  emailSubmitComplete(ugcType: 'answer' | 'reply'): void
  eventBus: EventBus
  iqrlId?: number // itemQuestionRecipientLogId
  showRegistration(registrationInfo: RegistrationInfo): void
  showError(message: string, endFlow: boolean, autoClosePopover: boolean): void
}

export class SubmissionContext implements ISubmissionContext {
  constructor() {
    this.eventBus = ContextEventBus()
  }

  answerText // from inbox submission
  iqrlId
  eventBus: EventBus

  confirmedSubmitComplete(info: ConfirmedSubmitInfo): void {
    this.eventBus.emit('confirmedSubmitComplete', info)
  }

  emailSubmitComplete(ugcType: 'answer' | 'reply'): void {
    this.eventBus.emit('emailSubmitComplete', ugcType)
  }

  showRegistration(registrationInfo: RegistrationInfo): void {
    this.eventBus.emit('showRegistration', registrationInfo)
  }

  showError(message: string, endFlow = false, autoClose = true): void {
    this.eventBus.emit('showError', message, endFlow, autoClose)
  }
}
